import { STATUSES, type LearnStatus } from "@69ly/shared";
import { useTranslation } from "react-i18next";
import { useSetStatus } from "../lib/stuff-queries.ts";

/** My learning status for a stuff. Pressing the current status again clears it. */
export function StatusControl({ stuffId, status }: { stuffId: string; status: LearnStatus | null }) {
  const { t } = useTranslation();
  const set = useSetStatus();
  return (
    <div className="segmented" role="group" aria-label={t("mapView.myStatus")}>
      {STATUSES.map((s) => (
        <button
          key={s}
          type="button"
          aria-pressed={status === s}
          className={`seg status-${s}`}
          disabled={set.isPending}
          onClick={() => set.mutate({ id: stuffId, status: status === s ? null : s })}
        >
          {t(`status.${s}`)}
        </button>
      ))}
    </div>
  );
}

export function StatusTag({ status }: { status: LearnStatus | null }) {
  const { t } = useTranslation();
  return <span className={`status-tag status-${status ?? "none"}`}>{t(`status.${status ?? "none"}`)}</span>;
}
